// import React from "react";

// const SimilarProperties = () => {
//   return (
//     <div className="row mt-4">

//       <div className="col-12">
//         <div className="propertylistouter">
//           <h4>Similar Properties</h4>
//           <div className="propertylistbx">
//             <img src="/images/property-img-1.jpg" alt="" />
//             <div className="propertycontents">
//               <h3>Bamboo Grove Retreat</h3>
//               <p>Experience warm hospitality with Himalayan views.</p>
//               <div className="pricetxt">₹ 9500 - ₹ 13000</div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SimilarProperties;

import React from "react";
import { Link } from "react-router-dom";

const SimilarProperties = ({ similar = [] }) => {
  if (!similar.length) return null;

  return (
    <div className="row mt-4">
      <div className="col-12">
        <div className="propertylistouter">
          <h4>Similar Properties</h4>

          <div className="row gx-2 gx-md-3 mt-3">
            {similar.map((item) => (
              <div key={item.id} className="col-md-4 col-sm-6 col-6 mb-3">

                <div className="topdealbx h-100">
                  <Link to={`/property/${item.id}`} className="topdealimg">
                    <img
                      src={item.cover_image}
                      alt={item.title}
                    />
                  </Link>
                  <div class="topdealcontent">
                    <div class="w-100">
                      <h3><Link to={`/property/${item.id}`}>{item.title}</Link></h3>
                      <p>{item.tagline || ""}</p>
                      <p>📍 {item.location_name || ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimilarProperties;
